import {CustomSelect, selectInstace} from "@soinproduction/kit";
import vars from "../_vars";
import {updateMap} from "./map";
import {fadeIn, fadeOut} from "@soinproduction/kit/src/functions/customFunctions";

document.addEventListener('DOMContentLoaded', () => {
    vars.selects.forEach(function (select) {
        const selectItem = new CustomSelect(select, {
            mode: select.dataset.type || 'single',
            name: select.dataset.name,
            placeholder: select.dataset.placeholder,
            showRemoveButton: !select.dataset.remove,
            hideOnClear: true,
            hideOnSelect: true,
            showInfo: false,
        });
    })

    const current = [...selectInstace.values()].find((inst) => inst?.config?.name === 'location');

    if (!current) return;

    current.onSelect(() => {
        const raw = current.getValues();
        const val = Array.isArray(raw) ? raw[0] : raw;
        const idx = parseInt(val, 10);

        document.querySelectorAll('[data-select-panel]').forEach((el) => {
            fadeOut(el,0)

            if (+el.dataset.selectPanel === idx) {
                setTimeout(function (){
                    fadeIn(el,0, 'flex');
                }, 0)
            }
        })

        if (!Number.isNaN(idx)) updateMap(idx);
    });
});
